import { apiFetch } from '@/lib/api-client/client';

/** Matches the Worker's /api/guilds/:guildId/resources response exactly
 * (routes/guild-resources.ts → bridge/config.py's handle_guild_resources →
 * discord.py's live guild.channels/guild.roles). IDs are always strings -
 * Discord snowflakes exceed JavaScript's safe integer range. */
export interface GuildChannel {
  id: string;
  name: string;
  type: 'text' | 'announcement' | 'forum' | 'category';
  parentId: string | null;
  parentName: string | null;
  position: number;
}

export interface GuildRole {
  id: string;
  name: string;
  position: number;
  managed: boolean;
  isEveryone: boolean;
}

export interface GuildResources {
  guildId: string;
  channels: GuildChannel[];
  roles: GuildRole[];
}

/** Permission errors propagate as ApiError('FORBIDDEN', ...); an
 * unreachable bot as ApiError('BOT_UNREACHABLE'/'BOT_DEGRADED', ...) -
 * callers (useGuildResources) turn both into a picker fallback state
 * rather than letting either throw out of a render. */
export function getGuildResources(guildId: string): Promise<GuildResources> {
  return apiFetch<GuildResources>(`/api/guilds/${guildId}/resources`);
}
